<script lang="ts" setup>
import { i18n } from '@/plugins/i18n';
import { Role } from '~~/data/enums/Role';
import { useUser } from '~~/stores/user';

const { role } = useUser();

const main = computed(() => [
  {
    title: i18n.global.t('sidebar.titles.general'),
    category: 'General',
    items: [
      {
        name: i18n.global.t('my_employer'),
        icon: 'company',
        to: '/admin/my-employer',
        permissions: ['admin:myemployer:read'],
      },
      {
        name: i18n.global.t('employers'),
        icon: 'company',
        to: '/admin/employers',
        permissions: ['admin:employers:read'],
      },
      ...(role !== Role.TripleAdmin ? [{
        name: i18n.global.t('teams'),
        icon: 'users',
        to: '/admin/teams',
        permissions: ['admin:teams:read'],
      }] : []),
      {
        name: i18n.global.t('employees'),
        customIcon: '/images/employees.svg',
        to: '/admin/employees',
        permissions: ['admin:employees:read'],
      },
      ...(role !== Role.TripleaReadonlyAdmin ? [{
        name: i18n.global.t('reports'),
        customIcon: '/images/reports.svg',
        to: '/admin/reports',
        permissions: ['admin:reports:read'],
      }] : []),
      ...(useConfiguration().FEATURE_SERVICE_ALERTS ? [{
        name: i18n.global.t('service_alerts.service_alerts'),
        icon: 'flash',
        to: '/admin/service-alerts',
        permissions: ['admin:servicealert:read'],
      }] : []),
    ]
  },
  {
    title: i18n.global.t('sidebar.titles.pa'),
    category: 'PA',
    items: [
      {
        name: i18n.global.t('profiles'),
        icon: 'stacks',
        to: '/admin/profiles',
        permissions: ['admin:profiles:read'],
      },
      {
        name: i18n.global.t('themes.themes'),
        icon: 'tag',
        to: '/admin/themes',
        permissions: ['admin:themes:read'],
      },
      {
        name: i18n.global.t('article_management'),
        icon: 'content',
        to: '/admin/articles',
        permissions: ['admin:articles:read'],
      }
    ]
  },
  {
    title: i18n.global.t('sidebar.titles.pe'),
    category: 'PE',
    items: [
      {
        name: i18n.global.t('sidebar.pages.competencies'),
        customIcon: '/images/competency.svg',
        to: '/admin/competencies',
        permissions: ['admin:competencies:read'],
      },
      {
        name: i18n.global.t('sidebar.pages.modules'),
        customIcon: '/images/module.svg',
        to: '/admin/modules',
        permissions: ['admin:modules:read'],
      },
      {
        name: i18n.global.t('sidebar.pages.qualifications'),
        customIcon: '/images/qualification.svg',
        to: '/admin/qualifications',
        permissions: ['admin:qualifications:read'],
      },
      {
        name: i18n.global.t('sidebar.pages.certificates'),
        customIcon: '/images/certificates.svg',
        to: '/admin/certificates',
        permissions: ['admin:certificates:read'],
      },
      {
        name: i18n.global.t('sidebar.pages.exam_bookings'),
        customIcon: '/images/laMark.svg',
        to: '/admin/lamark',
        permissions: ['admin:exams:read'],
      },
    ]
  }
])

const footerLinks = computed(() => [
  {
    name: i18n.global.t('terms_and_conditions'),
    to: '/terms-conditions',
    permissions: null,
  },
  {
    name: i18n.global.t('support'),
    to: '/admin/support',
    permissions: null,
  },
]);

</script>

<template>
  <SidebarLayout :mainLinks="main" :footerLinks="footerLinks">
    <slot></slot>
  </SidebarLayout>
</template>
